import React from 'react';
import { useIntl } from 'react-intl';
import SvgIcon from '@material-ui/core/SvgIcon';
import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.Dela.icon,
    fontSize: theme.spacing(3),
    margin: theme.spacing(-0.375)
  }
}));

const DelaStarIcon = React.forwardRef(({ className, ...rest }, ref) => {
  const intl = useIntl();
  const classes = useStyles();

  return (
    <SvgIcon
      {...rest}
      className={classNames(classes.root, className)}
      titleAccess={intl.formatMessage({
        id: 'dela.suggestedByDelaAI'
      })}
      ref={ref}
    >
      <path d="m14.16 7.32c0.3054 0 0.5738 0.2024 0.6577 0.4961l0.7416 2.596c0.3246 1.136 1.213 2.024 2.349 2.349l2.596 0.7416c0.2937 0.0839 0.4961 0.3523 0.4961 0.6577s-0.2024 0.5738-0.4961 0.6577l-2.596 0.7416c-1.136 0.3246-2.024 1.213-2.349 2.349l-0.7416 2.596c-0.0839 0.2937-0.3523 0.4961-0.6577 0.4961s-0.5738-0.2024-0.6577-0.4961l-0.7416-2.596c-0.3246-1.136-1.213-2.024-2.349-2.349l-2.596-0.7416c-0.2936-0.0839-0.4961-0.3523-0.4961-0.6577s0.2024-0.5738 0.4961-0.6577l2.596-0.7416c1.136-0.3246 2.024-1.213 2.349-2.349l0.7416-2.596c0.0839-0.2936 0.3523-0.4961 0.6577-0.4961z" />
      <path d="m6.96 3c0.1768 0 0.3322 0.1172 0.3808 0.2872l0.4294 1.503c0.1879 0.6578 0.7021 1.172 1.36 1.36l1.503 0.4294c0.17 0.04858 0.2872 0.204 0.2872 0.3808s-0.1172 0.3322-0.2872 0.3808l-1.503 0.4294c-0.6578 0.1879-1.172 0.7021-1.36 1.36l-0.4294 1.503c-0.04857 0.17-0.204 0.2872-0.3808 0.2872s-0.3322-0.1172-0.3808-0.2872l-0.4294-1.503c-0.1879-0.6578-0.7021-1.172-1.36-1.36l-1.503-0.4294c-0.17-0.04857-0.2872-0.204-0.2872-0.3808s0.1172-0.3322 0.2872-0.3808l1.503-0.4294c0.6578-0.1879 1.172-0.7021 1.36-1.36l0.4294-1.503c0.04858-0.17 0.204-0.2872 0.3808-0.2872z" />
    </SvgIcon>
  );
});

DelaStarIcon.propTypes = {
  className: PropTypes.string
};

export default DelaStarIcon;
